import styled from '@emotion/styled';

export const StyledDocumentDownloadAnchor = styled.a({
    display: 'flex',
});
